/* eslint-disable max-lines */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/self-closing-comp */
import React from 'react'

export const CreditCardImage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="43"
    fill="none"
    viewBox="0 0 60 43"
  >
    <path
      fill="#111F2F"
      d="M50.723.445 2.685 8.403a2.72 2.72 0 0 0-2.24 3.13l4.764 28.759a2.72 2.72 0 0 0 3.13 2.24l48.038-7.958a2.72 2.72 0 0 0 2.24-3.13L53.854 2.685a2.72 2.72 0 0 0-3.13-2.24"
    ></path>
    <mask
      id="mask0_4149_112882"
      width="59"
      height="43"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "luminance" }}
    >
      <path
        fill="#fff"
        d="M50.723.446 2.685 8.404a2.72 2.72 0 0 0-2.24 3.13l4.764 28.758a2.72 2.72 0 0 0 3.13 2.24l48.038-7.958a2.72 2.72 0 0 0 2.24-3.13L53.854 2.686a2.72 2.72 0 0 0-3.13-2.24"
      ></path>
    </mask>
    <g mask="url(#mask0_4149_112882)">
      <path
        fill="#054D80"
        d="M43.401 27.811q-.606-.014-1.217-.005-.003-.53.012-1.057.61-.01 1.217.005-.015.527-.012 1.057M47.65.955c-5.48 5.539-9.22 12.654-10.546 20.42q-.27.04-.543.085c-12.552 2.08-22.6 10.227-27.697 20.986l6.515-1.08a32.57 32.57 0 0 1 21.194-14.05q-.005.535.005 1.072a31.46 31.46 0 0 0-19.754 12.739l8.523-1.412a25 25 0 0 1 11.68-6.207l.054.337q.321 1.935.828 3.789l5.573-.923a32 32 0 0 1-.861-3.784l-.006-.033q.624.002 1.241.034c.21 1.223.491 2.42.836 3.582l4.985-.826q-.301-.935-.535-1.904a25 25 0 0 1 3.767 1.369l6.153-1.02-.312-1.881a31.5 31.5 0 0 0-10.331-3.91q-.015-.543-.01-1.082a32.6 32.6 0 0 1 10.113 3.615L57.383 24a37.2 37.2 0 0 0-8.25-2.48 26.55 26.55 0 0 1 5.955-11.374l-.993-5.994c-4.998 4.41-8.52 10.3-9.966 16.83a37 37 0 0 0-1.238-.027C44.414 13.84 48.313 7.44 53.865 2.764L53.407.001z"
      ></path>
    </g>
    <path
      fill="url(#pattern0_4149_112882)"
      d="M43.336 26.145h13.189v8.999H43.336z"
      opacity="0.64"
      transform="rotate(-9.407 43.336 26.145)"
    ></path>
    <path
      fill="#F16122"
      d="m51.527 26.646-2.931.486.872 5.267 2.932-.485z"
    ></path>
    <path
      fill="#ED1C24"
      d="M49.217 29.735a3.39 3.39 0 0 1 .843-2.846 3.395 3.395 0 1 0 .873 5.267 3.39 3.39 0 0 1-1.716-2.421"
    ></path>
    <path
      fill="#F99F1C"
      d="M55.919 28.625a3.396 3.396 0 0 1-4.984 3.532 3.39 3.39 0 0 0 .843-2.846 3.39 3.39 0 0 0-1.716-2.422 3.395 3.395 0 0 1 5.857 1.736M56.218 30.731l-.018-.108.043-.007-.003-.022-.111.018.004.022.043-.007.018.108zm.215-.036-.022-.13-.034.006-.024.096-.054-.083-.034.006.022.13.024-.004-.016-.099.05.079.025-.004.023-.091.016.098z"
    ></path>
    <path
      fill="#929292"
      d="M16.589 23.83c.06.484-.25.92-.698.976l-5.267.872c-.443.091-.877-.221-.976-.699l-.75-4.524c-.06-.485.253-.92.699-.976l5.267-.873c.442-.091.876.221.975.699z"
    ></path>
    <mask
      id="mask1_4149_112882"
      width="9"
      height="8"
      x="8"
      y="18"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "luminance" }}
    >
      <path
        fill="#fff"
        d="M16.571 23.729c.06.484-.252.92-.698.976l-5.267.873c-.44.09-.876-.221-.975-.7l-.75-4.523c-.06-.485.25-.92.698-.977l5.27-.873c.44-.09.876.222.975.7l.75 4.524z"
      ></path>
    </mask>
    <g mask="url(#mask1_4149_112882)">
      <path
        fill="#9B9B9B"
        d="m8.757 19.497-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#9C9C9C"
        d="m8.772 19.494-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#9D9D9D"
        d="m8.794 19.49-.019.004 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#9E9E9E"
        d="m8.811 19.488-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#9F9F9F"
        d="m8.829 19.484-.018.003 1.032 6.235.019-.004z"
      ></path>
      <path
        fill="#A0A0A0"
        d="m8.849 19.481-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A1A1A1"
        d="m8.868 19.478-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#A2A2A2"
        d="m8.884 19.475-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A3A3A3"
        d="m8.903 19.472-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A4A4A4"
        d="m8.92 19.469-.018.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#A5A5A5"
        d="m8.94 19.466-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A6A6A6"
        d="m8.96 19.463-.019.003L9.974 25.7l.019-.003z"
      ></path>
      <path
        fill="#A7A7A7"
        d="m8.976 19.46-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A8A8A8"
        d="m8.995 19.457-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#A9A9A9"
        d="m9.015 19.454-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path fill="#AAA" d="m9.032 19.45-.018.004 1.033 6.234.018-.003z"></path>
      <path
        fill="#ABABAA"
        d="m9.05 19.448-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#ACACAB"
        d="m9.071 19.445-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#ADADAC"
        d="m9.089 19.442-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#AEAEAD"
        d="m9.106 19.439-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#AFAFAE"
        d="m9.126 19.436-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#B0B0AF"
        d="m9.143 19.432-.018.004 1.033 6.234.018-.004z"
      ></path>
      <path
        fill="#B1B1B0"
        d="m9.163 19.43-.018.002 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#B2B2B1"
        d="m9.18 19.426-.018.003 1.033 6.235.018-.004z"
      ></path>
      <path
        fill="#B3B3B2"
        d="m9.2 19.423-.018.003 1.032 6.235.019-.004z"
      ></path>
      <path
        fill="#B4B4B3"
        d="m9.218 19.42-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#B5B5B4"
        d="m9.237 19.417-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#B6B6B5"
        d="m9.255 19.414-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#B7B7B6"
        d="m9.274 19.41-.018.004 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#B8B8B7"
        d="m9.292 19.408-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#B9B9B8"
        d="m9.31 19.405-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#BABAB9"
        d="m9.331 19.402-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#BBBBBA"
        d="m9.349 19.399-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#BCBCBB"
        d="m9.366 19.396-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#BDBDBC"
        d="m9.382 19.393-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#BEBEBD"
        d="m9.403 19.39-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#BFBFBE"
        d="m9.42 19.387-.018.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#C0C0BF"
        d="m9.44 19.383-.018.004 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#C1C1C0"
        d="m9.458 19.38-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#C2C2C1"
        d="m9.477 19.377-.018.003 1.033 6.235.018-.004z"
      ></path>
      <path
        fill="#C3C3C2"
        d="m9.495 19.374-.018.003 1.032 6.235.019-.003z"
      ></path>
      <path
        fill="#C4C4C3"
        d="m9.513 19.371-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#C5C5C4"
        d="m9.532 19.368-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#C6C6C5"
        d="m9.552 19.365-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#C7C7C6"
        d="m9.57 19.362-.02.003 1.034 6.234.018-.003z"
      ></path>
      <path
        fill="#C8C8C7"
        d="m9.585 19.36-.019.002 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#C9C9C8"
        d="m9.606 19.356-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#CBC9C8"
        d="m9.624 19.353-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#CCCAC9"
        d="m9.642 19.35-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#CDCBCA"
        d="m9.663 19.347-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#CECCCB"
        d="m9.68 19.344-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#CFCDCC"
        d="m9.696 19.34-.018.004 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#D0CECD"
        d="m9.716 19.338-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D1CFCE"
        d="m9.735 19.335-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D2D0CF"
        d="m9.753 19.331-.019.003 1.033 6.235.019-.003z"
      ></path>
      <path
        fill="#D3D1D0"
        d="m9.772 19.328-.018.003 1.033 6.235.018-.004z"
      ></path>
      <path
        fill="#D4D2D1"
        d="m9.79 19.325-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#D5D3D2"
        d="m9.808 19.322-.019.004 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D6D4D3"
        d="m9.827 19.32-.018.002 1.032 6.235.019-.004z"
      ></path>
      <path
        fill="#D7D5D4"
        d="m9.845 19.316-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D8D6D5"
        d="m9.864 19.313-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D9D7D6"
        d="m9.884 19.31-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path fill="#DAD8D7" d="m9.9 19.307-.02.003 1.034 6.234.018-.003z"></path>
      <path
        fill="#DBD9D8"
        d="m9.917 19.304-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#DCDAD9"
        d="m9.938 19.3-.018.004 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#DDDBDA"
        d="m9.956 19.298-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#DEDCDB"
        d="m9.976 19.295-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#DFDDDC"
        d="m9.995 19.292-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#E0DEDD"
        d="m10.01 19.289-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#E1DFDE"
        d="m10.03 19.286-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#E2E0DF"
        d="m10.048 19.282-.019.003 1.033 6.235.019-.003z"
      ></path>
      <path
        fill="#E3E1E0"
        d="m10.067 19.28-.018.002 1.033 6.235.018-.003z"
      ></path>
      <path
        fill="#E4E2E1"
        d="m10.087 19.276-.019.003 1.033 6.235.019-.003z"
      ></path>
      <path
        fill="#E5E3E2"
        d="m10.103 19.273-.019.003 1.033 6.235.018-.003z"
      ></path>
      <path
        fill="#E6E4E3"
        d="m10.122 19.27-.018.003 1.032 6.235.019-.003z"
      ></path>
      <path
        fill="#E7E5E4"
        d="m10.142 19.267-.019.003 1.033 6.235.018-.004z"
      ></path>
      <path
        fill="#E8E6E5"
        d="m10.16 19.264-.02.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#E9E7E6"
        d="m10.177 19.261-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#EAE8E6"
        d="m10.198 19.258-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#EBE9E7"
        d="m10.214 19.255-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#ECEAE8"
        d="m10.231 19.252-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#EDEBE9"
        d="m10.25 19.249-.018.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#EEECEA"
        d="m10.27 19.246-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#EFEDEB"
        d="m10.288 19.243-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#F0EEEC"
        d="m10.306 19.24-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#F1EFED"
        d="m10.325 19.237-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#F2F0EE"
        d="m10.343 19.234-.019.003 1.033 6.234.019-.003z"
      ></path>
      <path
        fill="#F3F1EF"
        d="m10.362 19.23-.018.003 1.033 6.235.018-.003z"
      ></path>
      <path
        fill="#F4F2F0"
        d="m10.38 19.227-.019.003 1.033 6.235.019-.003z"
      ></path>
      <path
        fill="#F5F3F1"
        d="m10.4 19.224-.02.003 1.034 6.235.018-.003z"
      ></path>
      <path
        fill="#F6F4F2"
        d="m10.417 19.222-.019.002 1.033 6.235.019-.003z"
      ></path>
      <path
        fill="#F7F5F3"
        d="m10.435 19.218-.019.003 1.033 6.235.018-.004z"
      ></path>
      <path
        fill="#F8F6F4"
        d="m10.452 19.215-.018.003 1.032 6.234.019-.003z"
      ></path>
      <path
        fill="#F9F7F5"
        d="m10.474 19.212-.019.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#F9F7F5"
        d="m10.494 19.209-.021.003 1.032 6.234.022-.003z"
      ></path>
      <path
        fill="#F8F6F4"
        d="m10.516 19.205-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#F7F5F3"
        d="m10.537 19.201-.021.004 1.032 6.234.022-.003z"
      ></path>
      <path
        fill="#F6F4F2"
        d="m10.559 19.198-.022.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#F5F3F1"
        d="m10.584 19.194-.021.004 1.032 6.234.022-.004z"
      ></path>
      <path
        fill="#F4F2F0"
        d="m10.604 19.19-.022.004 1.033 6.234.021-.003z"
      ></path>
      <path
        fill="#F3F1EF"
        d="m10.625 19.187-.021.004 1.032 6.234.022-.004z"
      ></path>
      <path
        fill="#F2F0EE"
        d="m10.647 19.183-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#F1EFED"
        d="m10.666 19.18-.021.003 1.032 6.235.022-.004z"
      ></path>
      <path
        fill="#F0EEEC"
        d="m10.69 19.176-.022.004 1.033 6.234.021-.004z"
      ></path>
      <path
        fill="#EFEDEB"
        d="m10.713 19.173-.022.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#EEECEA"
        d="m10.737 19.169-.022.003 1.033 6.235.021-.004z"
      ></path>
      <path
        fill="#EDEBE9"
        d="m10.756 19.166-.022.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#ECEAE8"
        d="m10.776 19.162-.022.003 1.033 6.235.021-.004z"
      ></path>
      <path
        fill="#EBE9E7"
        d="m10.799 19.158-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#EAE8E6"
        d="m10.819 19.155-.022.003 1.033 6.234.021-.003z"
      ></path>
      <path
        fill="#E8E7E6"
        d="m10.842 19.151-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#E7E6E5"
        d="m10.865 19.148-.021.003 1.033 6.234.021-.003z"
      ></path>
      <path
        fill="#E6E5E4"
        d="m10.885 19.144-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#E5E4E3"
        d="m10.907 19.14-.022.004 1.033 6.234.021-.003z"
      ></path>
      <path
        fill="#E4E3E2"
        d="m10.928 19.137-.022.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#E3E2E1"
        d="m10.951 19.133-.021.004 1.033 6.234.021-.004z"
      ></path>
      <path
        fill="#E2E1E0"
        d="m10.97 19.13-.02.003 1.032 6.234.022-.003z"
      ></path>
      <path
        fill="#E1E0DF"
        d="m10.994 19.126-.021.004 1.032 6.234.022-.004z"
      ></path>
      <path
        fill="#E0DFDE"
        d="m11.018 19.122-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#DFDEDD"
        d="m11.035 19.119-.021.003 1.033 6.235.021-.004z"
      ></path>
      <path
        fill="#DEDDDC"
        d="m11.059 19.115-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#DDDCDB"
        d="m11.08 19.112-.021.003 1.032 6.234.022-.003z"
      ></path>
      <path
        fill="#DCDBDA"
        d="m11.102 19.108-.022.003 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#DBDAD9"
        d="m11.123 19.104-.021.004 1.032 6.234.022-.003z"
      ></path>
      <path
        fill="#DAD9D8"
        d="m11.147 19.1-.022.004 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#D9D8D7"
        d="m11.168 19.097-.021.004 1.032 6.234.022-.004zM11.185 19.094l-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#D8D7D6"
        d="m11.201 19.091-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#D7D6D5"
        d="m11.22 19.089-.017.002 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#D6D5D4"
        d="m11.236 19.086-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#D5D4D3"
        d="m11.254 19.083-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D4D3D2"
        d="m11.273 19.08-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#D3D2D1"
        d="m11.29 19.077-.017.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#D2D1D0"
        d="m11.306 19.074-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#D1D0CF"
        d="m11.324 19.071-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#D0CFCE"
        d="m11.342 19.068-.018.003 1.033 6.234.017-.002z"
      ></path>
      <path
        fill="#CFCECD"
        d="m11.357 19.066-.017.002 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#CECDCC"
        d="m11.375 19.063-.018.003L12.39 25.3l.018-.003z"
      ></path>
      <path
        fill="#CDCCCB"
        d="m11.394 19.06-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#CCCBCA"
        d="m11.41 19.057-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#CBCAC9"
        d="m11.428 19.054-.018.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#CAC9C8"
        d="m11.445 19.051-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#C9C9C8"
        d="m11.46 19.048-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#C8C8C7"
        d="m11.48 19.045-.017.003 1.033 6.234.017-.002z"
      ></path>
      <path
        fill="#C7C7C6"
        d="m11.5 19.043-.018.002 1.033 6.234.018-.002z"
      ></path>
      <path
        fill="#C6C6C5"
        d="m11.515 19.04-.017.002 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#C5C5C4"
        d="m11.533 19.037-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#C4C4C3"
        d="m11.55 19.034-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#C3C3C2"
        d="m11.566 19.031-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#C2C2C1"
        d="m11.582 19.028-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#C1C1C0"
        d="m11.603 19.025-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#C0C0BF"
        d="m11.619 19.022-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#BFBFBE"
        d="m11.635 19.02-.018.002 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#BEBEBD"
        d="m11.654 19.017-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#BDBDBC"
        d="m11.67 19.014-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#BCBCBB"
        d="m11.685 19.011-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#BBBBBA"
        d="m11.705 19.008-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#BABAB9"
        d="m11.722 19.005-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#B8B9B8"
        d="m11.74 19.002-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path fill="#B7B8B7" d="m11.758 19-.018.002 1.033 6.234.017-.003z"></path>
      <path
        fill="#B6B7B6"
        d="m11.775 18.997-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#B5B6B5"
        d="m11.79 18.994-.017.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#B4B5B4"
        d="m11.81 18.99-.017.003 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#B3B4B3"
        d="m11.828 18.988-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#B2B3B2"
        d="m11.844 18.985-.018.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#B1B2B1"
        d="m11.861 18.982-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#B0B1B0"
        d="m11.879 18.98-.018.002 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#AFB0AF"
        d="m11.896 18.976-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#AEAFAE"
        d="m11.914 18.973-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#ADAEAD"
        d="m11.931 18.97-.017.004 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#ACADAC"
        d="m11.947 18.968-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#ABACAB"
        d="m11.967 18.965-.018.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#AAABAA"
        d="m11.984 18.962-.017.003L13 25.199l.017-.003z"
      ></path>
      <path
        fill="#A9AAA9"
        d="m12.002 18.959-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A8AAA9"
        d="m12.02 18.956-.018.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#A7A9A8"
        d="m12.037 18.953-.018.003 1.033 6.234.018-.002z"
      ></path>
      <path
        fill="#A6A8A7"
        d="m12.053 18.95-.018.003 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#A5A7A6"
        d="m12.07 18.948-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#A4A6A5"
        d="m12.088 18.945-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A3A5A4"
        d="m12.105 18.942-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#A2A4A3"
        d="m12.123 18.939-.018.003 1.033 6.234.018-.003z"
      ></path>
      <path
        fill="#A1A3A2"
        d="m12.14 18.936-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#A0A2A1"
        d="m12.156 18.933-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#9FA1A0"
        d="m12.172 18.93-.018.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#9EA09F"
        d="m12.191 18.928-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#9D9F9E"
        d="m12.209 18.925-.018.002 1.033 6.235.018-.003z"
      ></path>
      <path
        fill="#9C9E9D"
        d="m12.226 18.922-.017.002 1.033 6.235.017-.003z"
      ></path>
      <path
        fill="#9B9D9C"
        d="m12.244 18.919-.017.003 1.032 6.234.018-.003z"
      ></path>
      <path
        fill="#9A9C9B"
        d="m12.262 18.916-.018.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#999B9A"
        d="m12.277 18.913-.017.003 1.033 6.234.017-.003z"
      ></path>
      <path
        fill="#999B9A"
        d="m12.343 18.902-.066.011 1.033 6.234.066-.01z"
      ></path>
      <path
        fill="#9A9C9B"
        d="m12.41 18.891-.066.011 1.033 6.234.065-.01z"
      ></path>
      <path
        fill="#9B9D9C"
        d="m12.476 18.88-.066.011 1.033 6.234.066-.01z"
      ></path>
      <path
        fill="#9C9E9D"
        d="m12.54 18.87-.065.01 1.032 6.235.066-.011z"
      ></path>
      <path
        fill="#9D9F9E"
        d="m12.609 18.859-.066.01 1.033 6.235.066-.011z"
      ></path>
      <path
        fill="#9E9F9F"
        d="m12.673 18.848-.066.01 1.033 6.235.066-.011z"
      ></path>
      <path
        fill="#9FA0A0"
        d="m12.74 18.837-.066.01 1.033 6.235.065-.011z"
      ></path>
      <path
        fill="#A0A1A1"
        d="m12.802 18.826-.066.01 1.033 6.235.066-.01z"
      ></path>
      <path
        fill="#A1A2A2"
        d="m12.872 18.815-.065.01 1.032 6.235.066-.01z"
      ></path>
      <path
        fill="#A3A3A3"
        d="m12.935 18.804-.066.011 1.033 6.234.066-.01z"
      ></path>
      <path
        fill="#A4A4A3"
        d="m13.003 18.793-.066.011 1.033 6.234.066-.01z"
      ></path>
      <path
        fill="#A5A5A4"
        d="m13.066 18.782-.066.011 1.033 6.235.066-.011z"
      ></path>
      <path
        fill="#A6A6A5"
        d="m13.134 18.772-.066.01 1.033 6.235.066-.011z"
      ></path>
      <path
        fill="#A7A7A6"
        d="m13.199 18.76-.066.012 1.033 6.234.065-.011z"
      ></path>
      <path
        fill="#A8A7A7"
        d="m13.265 18.75-.066.01 1.033 6.235.066-.011z"
      ></path>
      <path
        fill="#A9A8A8"
        d="m13.331 18.739-.065.01 1.032 6.235.066-.011z"
      ></path>
      <path
        fill="#AAA9A9"
        d="m13.396 18.728-.066.01 1.033 6.235.066-.011z"
      ></path>
      <path
        fill="#ABAAAA"
        d="m13.464 18.717-.066.01 1.033 6.235.066-.01z"
      ></path>
      <path
        fill="#ACABAB"
        d="m13.529 18.706-.066.011 1.033 6.234.066-.01z"
      ></path>
      <path
        fill="#ACABAB"
        d="m13.552 18.702-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#ADACAC"
        d="m13.573 18.699-.022.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#AEADAD"
        d="m13.597 18.695-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#AFAEAE"
        d="m13.618 18.691-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#B0AFAF"
        d="m13.642 18.687-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#B1B0B0"
        d="m13.663 18.684-.022.003 1.032 6.235.023-.004z"
      ></path>
      <path
        fill="#B2B1B1"
        d="m13.687 18.68-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#B3B2B2"
        d="m13.71 18.676-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#B4B3B3"
        d="m13.73 18.672-.023.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#B5B4B4"
        d="m13.755 18.669-.023.003 1.033 6.235.023-.004z"
      ></path>
      <path
        fill="#B6B5B5"
        d="m13.777 18.665-.023.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#B7B6B6"
        d="m13.802 18.661-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#B8B7B7"
        d="m13.821 18.657-.022.004 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#B9B8B8"
        d="m13.843 18.654-.023.003 1.033 6.235.023-.004z"
      ></path>
      <path
        fill="#BAB9B9"
        d="m13.866 18.65-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#BBBABA"
        d="m13.89 18.646-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#BCBBBB"
        d="m13.913 18.642-.022.004 1.032 6.234.023-.004z"
      ></path>
      <path
        fill="#BDBCBC"
        d="m13.935 18.639-.023.003 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#BEBDBD"
        d="m13.96 18.635-.023.003 1.033 6.235.023-.004z"
      ></path>
      <path
        fill="#BFBEBE"
        d="m13.982 18.631-.023.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#C0BFBF"
        d="m14.003 18.627-.023.004 1.033 6.234.023-.003z"
      ></path>
      <path
        fill="#C1C0C0"
        d="m14.027 18.624-.023.003 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#C2C1C1"
        d="m14.048 18.62-.023.003 1.033 6.235.023-.004z"
      ></path>
      <path
        fill="#C4C3C2"
        d="m14.071 18.616-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#C5C4C3"
        d="m14.093 18.612-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#C6C5C4"
        d="m14.116 18.609-.022.003 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#C7C6C5"
        d="m14.14 18.605-.023.003 1.033 6.235.023-.004z"
      ></path>
      <path
        fill="#C8C7C6"
        d="m14.161 18.601-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#C9C8C7"
        d="m14.185 18.597-.023.004 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#CAC9C8"
        d="m14.206 18.594-.022.003 1.032 6.235.023-.004z"
      ></path>
      <path
        fill="#CBCAC9"
        d="m14.232 18.59-.023.003 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#CCCBCA"
        d="m14.253 18.586-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#CDCCCB"
        d="m14.273 18.582-.023.004 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#CECDCC"
        d="m14.298 18.578-.023.004 1.033 6.234.023-.003z"
      ></path>
      <path
        fill="#CFCECD"
        d="m14.32 18.575-.023.003 1.033 6.235.022-.004z"
      ></path>
      <path
        fill="#D0CFCE"
        d="m14.345 18.571-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#D1D0CF"
        d="m14.364 18.568-.022.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#D2D1D0"
        d="m14.39 18.564-.023.003 1.033 6.234.023-.003z"
      ></path>
      <path
        fill="#D3D2D1"
        d="m14.411 18.56-.022.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#D4D3D2"
        d="m14.433 18.556-.023.004 1.033 6.234.023-.004z"
      ></path>
      <path
        fill="#D5D4D3"
        d="m14.456 18.552-.022.004 1.032 6.234.023-.003z"
      ></path>
      <path
        fill="#D6D5D4"
        d="m14.478 18.548-.023.004 1.033 6.234.023-.003z"
      ></path>
      <path
        fill="#D7D6D5"
        d="m14.501 18.545-.022.003 1.032 6.235.023-.004z"
      ></path>
      <path
        fill="#D8D7D6"
        d="m14.523 18.541-.023.004 1.033 6.234.022-.004z"
      ></path>
      <path
        fill="#D9D8D7"
        d="m14.548 18.538-.023.003 1.033 6.234.023-.003z"
      ></path>
      <path
        fill="#DAD9D8"
        d="m14.57 18.534-.023.003 1.033 6.234.022-.003z"
      ></path>
      <path
        fill="#DAD9D8"
        d="m14.6 18.529-.032.005 1.033 6.234.031-.005z"
      ></path>
      <path
        fill="#D9D8D7"
        d="m14.632 18.523-.03.006 1.032 6.234.031-.005z"
      ></path>
      <path
        fill="#D8D7D6"
        d="m14.662 18.518-.031.005 1.033 6.234.03-.005z"
      ></path>
      <path
        fill="#D7D6D5"
        d="m14.691 18.513-.03.005 1.032 6.234.03-.005z"
      ></path>
      <path
        fill="#D6D5D5"
        d="m14.724 18.508-.03.005 1.032 6.234.031-.005z"
      ></path>
      <path
        fill="#D4D4D4"
        d="m14.754 18.503-.031.005 1.032 6.234.031-.005z"
      ></path>
      <path
        fill="#D3D3D3"
        d="m14.785 18.498-.031.005 1.033 6.234.03-.005z"
      ></path>
      <path
        fill="#D2D2D2"
        d="m14.816 18.493-.03.005 1.032 6.234.03-.005z"
      ></path>
      <path
        fill="#D1D1D1"
        d="m14.847 18.487-.03.006 1.032 6.234.031-.005z"
      ></path>
      <path
        fill="#D1D1D1"
        d="m14.863 18.485-.015.003 1.032 6.234.016-.003z"
      ></path>
      <path
        fill="#D0D0D0"
        d="m14.878 18.482-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#CFCFCF"
        d="m14.892 18.48-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#CECECE"
        d="m14.906 18.478-.015.002 1.032 6.234.015-.002z"
      ></path>
      <path
        fill="#CDCDCD"
        d="m14.923 18.475-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#CCC"
        d="m14.937 18.473-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#CBCBCB"
        d="m14.953 18.47-.015.002 1.032 6.235.015-.003z"
      ></path>
      <path
        fill="#CACACA"
        d="m14.97 18.468-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#C9C9C9"
        d="m14.982 18.465-.015.003L16 24.702l.015-.003z"
      ></path>
      <path
        fill="#C8C8C8"
        d="m14.998 18.463-.016.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#C7C7C7"
        d="m15.011 18.46-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#C6C6C6"
        d="m15.029 18.458-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#C4C4C4"
        d="m15.044 18.455-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#C3C3C3"
        d="m15.058 18.452-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#C2C2C2"
        d="m15.076 18.45-.016.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#C1C1C1"
        d="m15.087 18.448-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="silver"
        d="m15.105 18.445-.015.003 1.033 6.234.015-.003z"
      ></path>
      <path
        fill="#BFBFBF"
        d="m15.119 18.443-.015.002 1.032 6.234.015-.002z"
      ></path>
      <path
        fill="#BEBEBE"
        d="m15.134 18.44-.015.002 1.033 6.235.015-.003z"
      ></path>
      <path
        fill="#BDBDBD"
        d="m15.15 18.438-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#BCBCBC"
        d="m15.164 18.435-.016.002 1.033 6.235.015-.003z"
      ></path>
      <path fill="#BBB" d="m15.18 18.433-.016.002 1.033 6.234.015-.002z"></path>
      <path
        fill="#BABABA"
        d="m15.195 18.43-.015.003 1.032 6.234.016-.003z"
      ></path>
      <path
        fill="#BABABA"
        d="m15.208 18.428-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#B9B9B9"
        d="m15.223 18.425-.014.003 1.033 6.234.014-.003z"
      ></path>
      <path
        fill="#B8B8B8"
        d="m15.237 18.423-.014.002 1.032 6.234.015-.002z"
      ></path>
      <path
        fill="#B7B7B7"
        d="m15.253 18.42-.015.003 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#B6B6B6"
        d="m15.266 18.418-.014.003 1.033 6.234.014-.003z"
      ></path>
      <path
        fill="#B5B5B5"
        d="m15.28 18.416-.014.002 1.032 6.234.015-.002z"
      ></path>
      <path
        fill="#B4B4B4"
        d="m15.296 18.413-.015.003 1.033 6.234.014-.003z"
      ></path>
      <path
        fill="#B3B3B3"
        d="m15.31 18.411-.015.002 1.033 6.235.014-.003z"
      ></path>
      <path
        fill="#B2B2B2"
        d="m15.323 18.409-.014.002 1.032 6.234.015-.002z"
      ></path>
      <path
        fill="#B1B1B1"
        d="m15.337 18.406-.015.003 1.033 6.234.014-.003z"
      ></path>
      <path
        fill="#B0B0B0"
        d="m15.352 18.404-.014.002 1.033 6.235.014-.003z"
      ></path>
      <path
        fill="#AFAFAF"
        d="m15.366 18.401-.014.003 1.032 6.234.015-.003z"
      ></path>
      <path
        fill="#AEAEAE"
        d="m15.382 18.4-.015.002 1.033 6.234.014-.003z"
      ></path>
      <path
        fill="#ADADAD"
        d="m15.397 18.397-.014.002 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#ACACAC"
        d="m15.409 18.394-.014.003 1.032 6.234.015-.003z"
      ></path>
      <path
        fill="#AAA"
        d="m15.423 18.392-.015.003 1.033 6.234.014-.003z"
      ></path>
      <path
        fill="#A9A9A9"
        d="m15.438 18.39-.014.002 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#A8A8A8"
        d="m15.454 18.387-.014.003 1.032 6.234.015-.003z"
      ></path>
      <path
        fill="#A7A7A7"
        d="m15.468 18.385-.015.002 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#A6A6A6"
        d="m15.481 18.383-.014.002 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#A5A5A5"
        d="m15.495 18.38-.014.003 1.032 6.234.015-.003z"
      ></path>
      <path
        fill="#A4A4A4"
        d="m15.512 18.378-.014.002 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#A3A3A3"
        d="m15.524 18.375-.014.003 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#A2A2A2"
        d="m15.538 18.373-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#A1A1A1"
        d="m15.552 18.37-.015.003 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#A0A0A0"
        d="m15.569 18.368-.014.002 1.032 6.235.015-.003z"
      ></path>
      <path
        fill="#9F9F9F"
        d="m15.583 18.366-.015.002 1.033 6.234.015-.002z"
      ></path>
      <path
        fill="#9E9E9E"
        d="m15.594 18.364-.014.002 1.033 6.234.014-.002z"
      ></path>
      <path
        fill="#9D9D9D"
        d="m15.612 18.361-.014.002 1.032 6.235.015-.003z"
      ></path>
      <path
        fill="#9D9D9D"
        d="m15.68 18.35-.069.011 1.033 6.234.07-.011z"
      ></path>
    </g>
    <g fill="#322515" opacity="0.8">
      <path d="m10.991 19.12-.051.008 1.03 6.225.052-.008zM13.487 18.705l-.052.009 1.032 6.225.051-.008zM11.228 20.896l-2.207.365.009.052 2.207-.366zM16 20.106l-2.207.365.009.052 2.206-.366z"></path>
      <path d="m13.648 19.747-2.525.418.009.052 2.525-.419zM14.326 23.843l-2.525.419.009.053 2.525-.418zM11.457 22.2l-2.207.366.009.052 2.206-.366zM16.218 21.43l-2.206.365.008.052 2.207-.366zM11.694 23.615l-2.207.366-.008-.052 2.206-.366zM16.437 22.75l-2.207.366.01.054 2.206-.366z"></path>
    </g>
    <path
      fill="#fff"
      d="M20.004 22.393c-.048-.015-.119-.047-.13-.11a.4.4 0 0 1 .015-.178c.146-.409.18-.848.103-1.27a2.6 2.6 0 0 0-.478-1.13l-.115-.156a.17.17 0 0 1 .065-.142.17.17 0 0 1 .2-.012.5.5 0 0 1 .112.135c.197.256.343.545.432.851q.105.369.146.746c.018.327-.026.654-.13.967-.059.184-.089.279-.155.29l-.064.01zm-.638-.203a.174.174 0 0 1-.141-.176q.021-.096.058-.184a1.93 1.93 0 0 0-.31-1.753c-.115-.156-.12-.18-.091-.272a.173.173 0 0 1 .233-.063l.002.002q.177.203.317.43a2.3 2.3 0 0 1 .202 1.617c-.084.3-.156.4-.27.397zm-.665-.22a.23.23 0 0 1-.13-.11.32.32 0 0 1 .037-.181c.134-.41.06-.854-.199-1.199-.115-.155-.122-.2-.068-.275a.15.15 0 0 1 .101-.06c.087-.015.138.02.25.157.146.201.246.434.291.678.052.245.03.5-.058.736-.04.16-.076.212-.142.223-.005.029-.034.047-.064.043a.1.1 0 0 1-.02-.008zm-.613-.185a.14.14 0 0 1-.104-.092c-.029-.04-.014-.085.016-.178a.65.65 0 0 0-.106-.643.4.4 0 0 1-.062-.099.17.17 0 0 1 .098-.215q.093-.048.219.095a.94.94 0 0 1 .166 1.007.24.24 0 0 1-.225.124zM17.925 11.77l-.553.092a1.3 1.3 0 0 0-1.082 1.185l-.037 1.365.752-.124.031-1.16a.55.55 0 0 1 .459-.529l.414-.068zM11.41 13.986c.021-.718.551-1.265 1.258-1.382.644-.107 1.114.219 1.131.775l-.767.127c-.031-.172-.191-.273-.427-.234-.235.04-.428.245-.436.588-.006.358.207.574.49.527.206-.034.327-.184.367-.371l.786-.13c-.026.572-.567 1.059-1.123 1.15-.754.129-1.3-.334-1.279-1.05M14.946 12.227c-.48.08-.838.378-.967.72l.633.17c.031-.15.178-.336.368-.368.214-.035.318.068.308.232-.009.094-.066.16-.169.177l-.42.07c-.399.065-.758.314-.77.788a.66.66 0 0 0 .784.683c.297-.049.489-.217.55-.423l-.006.296.75-.124.04-1.478c.01-.533-.467-.848-1.1-.743zm.337 1.471c-.003.209-.164.4-.345.43-.182.03-.287-.061-.28-.196.005-.134.112-.202.245-.223l.383-.064zM19.53 11.467c-.284.047-.484.17-.62.342l.003-.205-.753.124-.087 3.016.753-.125.022-.783c.123.088.37.116.63.073.637-.106 1.043-.635 1.061-1.349.027-.715-.445-1.186-1.01-1.093m.26 1.158c-.002.33-.2.61-.47.665-.277.055-.478-.145-.476-.471.001-.329.203-.611.476-.666.27-.054.475.149.47.472M24.656 10.655l-.553.092a1.3 1.3 0 0 0-1.083 1.185l-.037 1.365.752-.124.032-1.16a.554.554 0 0 1 .462-.53l.41-.068zM21.68 11.111c-.481.08-.838.378-.968.72l.634.17c.03-.15.177-.336.367-.368.214-.035.319.069.309.232-.01.094-.067.16-.17.177l-.417.069c-.398.066-.757.315-.769.788a.66.66 0 0 0 .784.684c.296-.05.488-.218.55-.423l-.007.296.75-.125.04-1.477c.011-.533-.469-.848-1.104-.742m.339 1.47c-.003.21-.163.4-.345.43s-.286-.06-.28-.195.112-.202.245-.224l.383-.063zM26.326 11.93l.634-.105c.012.166.188.252.384.22.169-.029.29-.123.27-.238-.051-.314-1.068.196-1.209-.653-.076-.456.392-.89.894-.974.553-.091.974.168.994.627l-.64.106c-.02-.155-.186-.242-.34-.216s-.264.117-.241.25c.053.324 1.094-.234 1.234.612.085.517-.319.944-.938 1.046-.574.098-1.027-.2-1.043-.674M25.628 11.134l.58-.097.014-.641-.58.096.019-.64-.752.125-.057 2.151c-.02.537.35.799.863.714l.444-.074.021-.64-.329.055c-.145.024-.248-.052-.244-.217z"
    ></path>
    <path
      fill="#F37B26"
      d="m28.965 11.894-.012.412-.42.07.012-.412zM29.1 11.444c.016-.49.376-.863.86-.943.437-.073.76.15.77.527l-.523.087c-.023-.117-.13-.187-.29-.16-.151.025-.292.166-.3.4-.003.243.143.393.336.36.139-.022.22-.126.25-.252l.535-.088c-.02.39-.387.722-.764.784-.516.092-.889-.225-.873-.715M30.921 11.316c-.11-.534.248-1.013.792-1.103.426-.07.786.175.86.55.11.534-.248 1.012-.791 1.103-.426.07-.786-.175-.86-.55m1.146-.407c-.03-.184-.158-.281-.33-.252-.239.04-.35.284-.313.51.03.185.158.282.33.253.242-.04.35-.284.313-.511M32.836 10.052l.514-.085-.005.193a.66.66 0 0 1 .442-.29c.239-.04.378.033.455.198a.77.77 0 0 1 .509-.358c.374-.062.59.173.582.534l-.028 1.013-.514.085.027-.908c.004-.18-.087-.28-.235-.256s-.247.156-.251.336l-.027.908-.514.085.027-.907c.004-.181-.087-.28-.235-.256s-.247.156-.251.336l-.027.908-.514.085zM35.204 9.405l-.009-.052.272-.045.009.052-.106.017.048.287-.06.01-.048-.287zM35.55 9.295l.076-.013.14.228h.004l.059-.261.075-.013.056.338-.06.01-.039-.232h-.003l-.055.249-.045.007-.132-.217h-.003l.038.233-.06.01zM6.477 15.818a.937.937 0 0 1-.216-1.305.92.92 0 0 1 .605-.377l2.302-.381a.73.73 0 0 0 .602-.842.73.73 0 0 0-.841-.602l-1.27.21-.115.593 1.48-.245a.164.164 0 0 1 .19.136.164.164 0 0 1-.136.19l-2.302.381q-.3.05-.557.214a1.494 1.494 0 0 0-.68 1.516q.05.299.213.557.158.246.395.419a1.5 1.5 0 0 0 1.12.26l.989-.163.116-.593-1.197.198a.97.97 0 0 1-.698-.167z"
    ></path>
    <path
      fill="#F37B26"
      d="M10.317 12.23a1.495 1.495 0 0 0-1.516-.68l-.987.164-.116.593 1.196-.198a.94.94 0 0 1 .697.16.93.93 0 0 1-.393 1.676l-2.298.38a.73.73 0 0 0-.602.842.73.73 0 0 0 .841.603l1.269-.21.116-.594-1.477.245a.164.164 0 0 1-.19-.136c-.015-.09.047-.166.137-.181l2.302-.381q.3-.05.558-.214a1.495 1.495 0 0 0 .464-2.07M8.578 16.32a.13.13 0 0 1-.06-.002.2.2 0 0 1-.05-.023.1.1 0 0 1-.038-.04c-.008-.017-.018-.034-.021-.056a.13.13 0 0 1 .002-.06.2.2 0 0 1 .023-.05.1.1 0 0 1 .04-.037q.024-.015.056-.022a.1.1 0 0 1 .06.003q.03.008.05.022.022.015.037.04t.022.056a.13.13 0 0 1-.003.06.2.2 0 0 1-.022.05.1.1 0 0 1-.04.038.1.1 0 0 1-.056.021m-.006-.036a.1.1 0 0 0 .052-.024.1.1 0 0 0 .032-.046.1.1 0 0 0 .006-.057.1.1 0 0 0-.024-.052.1.1 0 0 0-.045-.032.1.1 0 0 0-.057-.006.11.11 0 0 0-.085.07.1.1 0 0 0-.006.056.11.11 0 0 0 .07.084c.016.007.039.01.057.007m-.06-.037-.021-.133.066-.011q.009-.001.022.002c.01.002.014.007.021.013q.01.008.01.023a.1.1 0 0 1-.002.025c-.005.007-.007.014-.015.018a.1.1 0 0 1-.02.01l-.049.008-.004-.024.04-.007.01-.008q.005-.005.003-.019-.003-.011-.008-.014-.007-.003-.013-.001l-.027.004.019.112-.03.005v-.003zm.076-.074.043.058-.033.005-.04-.058z"
    ></path>
    <defs>
      <pattern
        id="pattern0_4149_112882"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use transform="scale(.00394 .00575)"></use>
      </pattern>
      <image
        id="image0_4149_112882"
        width="254"
        height="174"
        preserveAspectRatio="none"
      ></image>
    </defs>
  </svg>
)
